// theme.js
import { createGlobalStyle } from 'styled-components';

import "./global.css"

const theme = {
  colors: {
    primary: "#FEE20E",  // Canlı kırmızı
    secondary: "#342E72",  // Elektrik mavisi
    success: "#2ECC71",  // Canlı yeşil
    danger: "#E74C3C",  // Koyu kırmızı
    warning: "#F1C40F",  // Parlak sarı
    info: "#9B59B6",  // Mor ton
    light: "#FFFFFF",  // Açık gri
    dark: "#000000",  // Koyu mavi-gri
    background: "#0F172A",  // Koyu gece mavisi
    activeLink: "#534BA6",  // Canlı kırmızı
    gradient1:"linear-gradient(360deg, #876BC6 0%, #7859C1 55.98%, #6E4EBB 111.96%)" , // Gradient 1
    text: {
      light: "#FFFFFF", 
      secondary:"#B1DAF1", // Açık gri
      dark: "#2C3E50",  // Koyu mavi-gri
      gradient:"linear-gradient(0deg, #B6F6FF, #B6F6FF),linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)"
    },  // Açık gri-beyaz
    border: "#7a858e",  
    dangerHover: "#e74c3c",
    overlay: "rgba(0, 0, 0, 0.5)"
  },
  fonts: {
    primary: "'Poppins', serif;",
    secondary: "'Montserrat', sans-serif"
  },
  modalWidth: "500px",
  zIndex: {
    modal: 1000
  },
  shadows: {
    modal: "0 5px 15px rgba(0,0,0,0.3)",
    card: "0px 4px 25.9px 0px #FFFFFF73;",
    cardHover: "0 6px 15px rgba(0,0,0,0.2)",
  },
  yellow: {
    gradient:
      "linear-gradient(180deg, #FEE20E 26.5%, #FCD113 36%, #FCD113 64%, #F6BA06 97%)",
    background: "#F8CB1F",
  },
  spacing: (factor) => `${factor * 8}px`,
};

export const GlobalStyles = createGlobalStyle`
    :root {
        --vw: min(1vw, 4.2px); /* 1vw ama max 420px baz alınacak */
    }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family:"WoodHeinzNo4-Regular" ;//${(props) => props.theme.fonts.primary};
    line-height: 1;
    ::-webkit-scrollbar{
      display:none;
    }
  }

  body {
    background-color: ${(props) => props.theme.colors.light};
    color: ${(props) => props.theme.colors.light};
    margin:0;
    overflow: hidden;
  }
`;

export default theme;
